;(function(){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      expiryTime: null,
      currentTime: new Date().getTime(),
      timerRunning: false
    };
  },
  mounted: function mounted() {
    this.startTimer();
  },


  computed: {
    remainingTime: function remainingTime() {
      var timeLeft = this.expiryTime - this.currentTime;
      if (timeLeft < 0) return "00:00";
      var minutes = String(Math.floor(timeLeft % (1000 * 60 * 60) / (1000 * 60))).padStart(2, '0');
      var seconds = String(Math.floor(timeLeft % (1000 * 60) / 1000)).padStart(2, '0');
      return minutes + ':' + seconds;
    }
  },

  methods: {
    startTimer: function startTimer() {
      this.expiryTime = new Date().getTime() + 120000;
      this.timerRunning = true;
      this.updateTime();
      this.timerInterval = setInterval(this.updateTime, 1000);
    },
    updateTime: function updateTime() {
      this.currentTime = new Date().getTime();
      if (this.currentTime >= this.expiryTime) {
        clearInterval(this.timerInterval);
        this.timerRunning = false;
        this.$emit("update:timer", false);
      }
    }
  },

  beforeDestroy: function beforeDestroy() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("OTP expires in "+_vm._s(_vm.remainingTime))])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4910170b", __vue__options__)
  } else {
    hotAPI.reload("data-v-4910170b", __vue__options__)
  }
})()}